import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';

import Mission from './components/Mission';
import Strategy from './components/Strategy';
import Challenges from './components/Challenges';
import JoinUs from './components/JoinUs';

import useScrollToHash from './hooks/useScrollToHash';
import { Toaster } from 'react-hot-toast';

function App() {
  useScrollToHash();

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

import SEO from './components/SEO';

export const Home = () => (
  <>
    <SEO 
      title="Healthier Smile Initiatives - Restoring Smiles in Sierra Leone"
      description="Join Healthier Smile Initiatives in our mission to provide essential medical and dental care to underserved communities in Sierra Leone. Learn about our story, strategy, and how you can help."
      name="Healthier Smile Initiatives"
      type="website"
    />
    <Hero />
    <Mission />
    <Strategy />
    <Challenges />
    <JoinUs />
  </>
);

export default App;